// extracted by mini-css-extract-plugin
export default {"info":"IconWithPopupInfo_info__0yv4r"};